import { Controller } from 'stimulus';
import multi from 'multi.js/dist/multi-es6.min';

export default class extends Controller {
  initialize() {
    multi(this.element);
  }
}
